module.exports = __webpack_public_path__ + "ab1.no1.cacc5a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ab1.no1.jpg
// module id = 8qWW
// module chunks = 0